import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';
import type { LivePageComponentProps } from '../src/LivePageComponent.tsx';

export const LivePageComponentLoader: LoadableType<LivePageComponentProps> = LoadablePaint({
	name: MustPreloadLoadableNames.LivePageComponentLoader,
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LivePageComponent" */ '../src/LivePageComponent.tsx'
			)
		).LivePageComponent,
});
